import React from 'react';
import { FiHome, FiBook, FiVideo, FiAward, FiUser, FiFileText } from 'react-icons/fi';

export const getLearnerMenu = () => [
  { icon: <FiHome />, label: 'Dashboard', path: '/learner' },
  { icon: <FiBook />, label: 'My Learning', path: '/learner/courses' },
  { icon: <FiVideo />, label: 'Browse Courses', path: '/learner/browse' },
  { icon: <FiFileText />, label: 'Publications', path: '/learner/publications' },
  { icon: <FiAward />, label: 'Badges', path: '/learner/badges' },
  { icon: <FiUser />, label: 'Profile', path: '/learner/profile' },
];


